import styled from '@emotion/styled';
import { CDS_ZINDEX } from '@revenuemarket/cds';

import { ModalBaseProps } from '../types/modal';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${CDS_ZINDEX.POP_UP};
`;

export const Background = styled.div<{ isBlur: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(17, 17, 17, 0.7);
  ${({ isBlur }) => isBlur && `backdrop-filter: blur(2px);`}
`;

export const ModalContent = styled.div<Pick<ModalBaseProps, 'inlineCss' | 'isFullSize' | 'isBlur'>>`
  position: absolute;
  min-width: 375px;
  min-height: 80px;
  border-radius: 4px;
  overflow-y: auto;
  ${({ inlineCss }) => inlineCss};
  ${({ isFullSize }) =>
    isFullSize
      ? `
    top: 0;
    left: 0;
    transform: inherit;
    height: 100vh;
  `
      : `
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  max-height: calc(100vh - 80px);
  `}
`;

export const BottomsheetContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  border-radius: 4px;
  letter-spacing: -0.35px;
  line-height: 1.4;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;

  &:focus {
    outline: none;
  }
`;

export const ButtonClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
  padding: 0;
  text-align: center;
  background: none;
  border-width: 0;
  z-index: 30;
  cursor: pointer;
`;
